import { useQuery } from '@tanstack/react-query';
import { Card } from 'antd';
import { CSSGrid } from '@/common/components';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import ContentSummaryCard from '@/apps/ip-creator/components/ContentSummaryCard';
import { queryIpCreatorContents } from '@/apps/ip-creator/services/ip-creator';
import { buildContentSummaryItems } from '@/apps/ip-creator/utils/contents';

export default function WorkplaceContentCreation() {
  const { organizationId, resolveOrganizationPath } = useOrganizationPath();
  const { data = {}, isLoading } = useQuery({
    enabled: Boolean(organizationId),
    queryFn: () => queryIpCreatorContents({ organizationId }),
    queryKey: ['workplace', 'ip-creator', 'contents', organizationId],
  });
  const summaryItems = buildContentSummaryItems({ data, resolveOrganizationPath });

  return (
    <Card title="内容创作" variant="borderless">
      <CSSGrid columns={{ xs: 1, sm: 2, xl: 4 }} gap="large">
        {summaryItems.map((item) => (
          <ContentSummaryCard
            key={item.title}
            item={item}
            loading={isLoading}
            size="small"
            type="inner"
          />
        ))}
      </CSSGrid>
    </Card>
  );
}
